<header class="select-none" *transloco="let t">
  <div class="clearfix">
    <div class="px-8 py-1">
      <div class="float-left">
        <a
          class="relative inline-block mt-4 mb-4 no-underline whitespace-no-wrap p-ripple text-grey-dark hover:text-grey-dark"
          pRipple
          [routerLink]="['/']"
        >
          <span class="relative float-left mr-3 top-1 mt-3px">
            <svg
              xmlns="https://www.w3.org/2000/svg"
              viewBox="0 0 191 71"
              class="relative inline-block w-auto h-6"
            >
              <path
                d="M173.592 5.295c-8.25 1.334-12.469 7.428-12.469 18.154 0 10.79 5.619 18.008 14.235 18.008 4.008 0 7.65-1.332 15.305-5.087v8.73c-9.188 4.214-14.597 5.518-22 5.518-8.016 0-13.655-2.128-18.26-6.823-4.72-4.721-7.08-10.957-7.08-17.898C143.323 10.45 154.758 0 171.46 0c11.093 0 18.723 5.068 18.723 12.512 0 4.792-3.55 8.089-8.82 8.089-2.706 0-4.927-.708-7.77-2.359V5.295zm-40.716 20.601c7.398-9.327 10.011-13.087 10.011-17.667 0-4.558-3.62-8.229-8.455-8.229-2.977 0-5.66 1.405-6.968 2.868v18.997l-12.121 16.151V1.195h-11.524l-19.157 31.76V1.195h-6.623l-17.39 4.24V9.88l9.485.963v38.949h12.261l18.375-30.196v30.196h13.426l18.68-23.896zM31.983 66.848l-7.951-1.768V49.314c3.187.366 6.277.479 8.136.479 16.428 0 26.853-10.515 26.853-26.141 0-13.52-7.813-23.283-18.398-23.283-4.584 0-7.655.941-16.591 6.259V.12h-4.95L0 5.917v4.673h7.9v54.49L.792 66.848v4.51h31.19v-4.51zm-5.248-22.991c-.826 0-1.398 0-2.703-.061V11.094c2.819-.342 4.216-.504 5.547-.504 7.994 0 12.326 5.314 12.326 15.306 0 11.804-5.294 17.96-15.17 17.96z"
                fill-rule="evenodd"
              ></path>
            </svg>
          </span>
          <span class="relative inline-block text-2xl text-black -left-2px">
            {{ t("appname") }}
          </span>
        </a>
      </div>
      <div class="float-right">
        @if (user) {
          <div class="inline-block px-4 mt-4 mr-1px">
            <p-menu
              #accountMenu
              [popup]="true"
              [model]="accountMenuItems"
              appendTo="body"
            ></p-menu>
            <div
              (click)="accountMenu.toggle($event)"
              pRipple
              class="relative pr-1 text-right cursor-pointer lg:pr-5 -top-2px"
            >
              <span class="text-3xl icon-avatar-outline lg:hidden"></span>
              <div class="hidden lg:inline-block">
                <span
                  class="absolute right-0 mt-1 text-xs inline-bsck icon-chevronDown-outline"
                ></span>
                <p>{{ user.displayName }}</p>
                <p class="relative text-sm text-grey-medium/75">
                  {{ user.email }}
                </p>
              </div>
            </div>
          </div>
        }
        <language-switcher></language-switcher>
      </div>
    </div>
  </div>
  <nav class="clearfix bg-grey-dark">
    <div class="px-8">
      @if (menuItems) {
        <ul class="flex justify-start p-0 m-0 leading-7 menu">
          @for (item of menuItems; track item) {
            <li
              #menuItem
              class="relative m-0 cursor-pointer hover:bg-grey-darker"
              [routerLinkActive]="'active'"
              #rlaTop="routerLinkActive"
              [routerLinkActiveOptions]="{ exact: true }"
              [toggleClassOnClick]="'open'"
              [toggleClassOnClickIf]="!!item.children"
              (clickOutside)="onClickedOutside($event, menuItem)"
            >
              <a
                [routerLink]="['/' + item.page.route]"
                [style.pointerEvents]="item.children ? 'none' : 'auto'"
                pRipple
                class="block py-2 pl-4 pr-6"
                [class.text-white]="!rlaTop.isActive"
                [class.text-orange-default]="rlaTop.isActive"
              >
                <span class="{{ item.page.icon }} mr-2"></span>
                <span class="inline-block select-none my-1px">{{
                  t(item.page.title)
                }}</span>
                @if (item.children) {
                  <span class="ml-1 text-xs icon-chevronDown-outline"></span>
                }
              </a>
              @if (item.children) {
                <ul
                  class="absolute overflow-hidden whitespace-nowrap submenu bg-grey-dark"
                >
                  @for (child of item.children; track child) {
                    <li
                      [routerLinkActive]="'active'"
                      #rlaChild="routerLinkActive"
                      class="relative block overflow-hidden"
                    >
                      <a
                        [routerLink]="[
                          '/' + item.page.route + '/' + child.page.route,
                        ]"
                        class="relative block pt-3 pb-2 pl-4 pr-6 overflow-hidden hover:bg-grey-darker"
                        [class.text-white]="!rlaChild.isActive"
                        [class.text-orange-default]="rlaChild.isActive"
                      >
                        <span class="{{ child.page.icon }} mr-2"></span>
                        <span class="select-none">{{
                          t(child.page.title)
                        }}</span>
                      </a>
                    </li>
                  }
                </ul>
              }
            </li>
          }
        </ul>
      }
    </div>
  </nav>
</header>
